function validateSignupForm() {
    const formSignup = document.querySelector('.js-signup-form');
    const emailInput = document.querySelector('.js-signup-email-field');
    const passwordInput = document.querySelector('.js-signup-password-field');
    const emailError = document.querySelector('.js-signup-email-sign');
    const passwordError = document.querySelector('.js-signup-password-sign');

    let emailDefaultState = true;
    let passwordDefaultState = true;

    $(emailInput).on('blur', function () {
        if ($(this).val() != '' && emailDefaultState == true) {
            emailDefaultState = false;
            validateEmail(emailInput, emailError);
        }
    });

    $(passwordInput).on('blur', function () {
        if ($(this).val() != '' && passwordDefaultState == true) {
            passwordDefaultState = false;
            validatePassword(passwordInput, passwordError);
        }
    });

    $(formSignup).submit(function (e) {
        e.preventDefault();

        if (
            validateEmail(emailInput, emailError) &&
            validatePassword(passwordInput, passwordError)
        ) {
            $(this)
                .off('submit')
                .on('submit', function () {
                    return true;
                });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });

    emailInput.addEventListener('input', () => {
        if (!emailDefaultState) {
            validateEmail(emailInput, emailError);
        }
    });

    passwordInput.addEventListener('input', () => {
        if (!passwordDefaultState) {
            validatePassword(passwordInput, passwordError);
        }
    });

    $(document, '.mdl-wrap').on(
        'click',
        '.js-btn-field-clear-email',
        function () {
            setTimeout(() => {
                validateEmail(emailInput, emailError);
            }, 0);
        }
    );
}

runIfElementExist(validateSignupForm, '.js-signup-form');
